<template>
  <td>
    <label class="switch" v-if="dataItem.activated == true || dataItem.activated == false">
      <input type="checkbox" v-model="dataItem.activated" @change="changeHandler($event)" />
      <span class="slider round"></span>
    </label>
    <label class="switch" v-if="dataItem.isActive == true || dataItem.isActive == false">
      <input type="checkbox" v-model="dataItem.isActive" @change="changeHandlerClient($event)" />
      <span class="slider round"></span>
    </label>

  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    active: Boolean,
    columnIndex: Number,
  },
  methods: {
    changeHandler: function () {
      this.$emit("confirm", {
        dataItem: this.item,
        active: this.dataItem.activated,
      });
    },
    changeHandlerClient: function () {
      this.$emit("confirm", {
        dataItem: this.item,
        active: this.dataItem.isActive,
      });
    }
  },
  watch: {
    dataItem: function (newVal) {
      this.item = newVal;
    },
  },

  data: function () {
    return {
      item: { ...this.dataItem },
    };
  },
};
</script>
 
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 57px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 19px;
  left: 6px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch input:checked + .slider {
  background-color: #043d96;
}

.switch input:focus + .slider {
  box-shadow: 0 0 1px#043d96;
}

.switch input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.switch .slider.round {
  border-radius: 34px;
}

.switch .slider.round:before {
  border-radius: 50%;
}
</style>
